import React from 'react'
import RecallTable from './RecallTable'

function Recalls() {
    

  return (
   <>
     <div className="container container-xxl">
        <div className="pagetitle">
            <h1>Recall Requests</h1>
        </div>
        <RecallTable/>
        
   </div>
   </>
  )
}

export default Recalls